import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.png";
import Particle from "../Particle";
import Activity from "../Activities/Activity";




function ImpactHome() {



  return (
    <section>
      <Container fluid className="home-section" id="home">     
        <Particle />       
        <Container className="home-content">   
       
          <Row>
            <Col md={7} className="home-header">             
              <h1 style={{ paddingBottom: 15 }} className="heading">
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "700px" }}
              />Choicest Fruit<span className="small-r-symbol">®</span>{" "}              
              </h1>

              <h1 className="heading-name">
                <i>Knowledge and Technology
                  <strong className="main-name"> Serving the Welfare of Humanity</strong></i>
                
              </h1>
             
              
            </Col>
          
          
          </Row>
        </Container>        
      </Container>     
<Activity/>
    </section>
  );
}

export default ImpactHome;
